import type { TFunction } from 'i18next'
import type { TimelineEvent } from '../ConstructionTimelineTab.types'
import { TIMELINE_COLORS } from '../ConstructionTimelineTab.constants'

export const buildTimelineEvents = (
  buildingYear: number,
  renovationYear: number,
  constructionDates: number[],
  dwellingYears: number[],
  isAgeEstimate: boolean,
  currentYear: number,
  t: TFunction
): TimelineEvent[] => {
  const events: TimelineEvent[] = []

  if (buildingYear > 0) {
    events.push({
      year: buildingYear,
      label: isAgeEstimate
        ? t('timeline.events.originalConstructionEst')
        : t('timeline.events.originalConstruction'),
      color: TIMELINE_COLORS.CONSTRUCTION,
    })
  }

  if (renovationYear > 0) {
    events.push({
      year: renovationYear,
      label: t('timeline.events.majorRenovation'),
      color: TIMELINE_COLORS.RENOVATION,
    })
  }

  // Add construction dates from administrative data
  constructionDates.forEach((date: number) => {
    if (date && date !== buildingYear && date !== renovationYear) {
      events.push({
        year: date,
        label: t('timeline.events.constructionPhase'),
        color: TIMELINE_COLORS.CONSTRUCTION_PHASE,
      })
    }
  })

  // Add dwelling years (always show, even if they match other dates)
  dwellingYears.forEach((year: number) => {
    if (year && year !== buildingYear && year !== renovationYear) {
      events.push({
        year: year,
        label: t('timeline.events.dwellingAdded'),
        color: TIMELINE_COLORS.DWELLING_ADDED,
      })
    }
  })

  events.push({
    year: currentYear,
    label: t('timeline.events.present'),
    color: TIMELINE_COLORS.PRESENT,
  })

  // Sort events by year
  events.sort((a, b) => a.year - b.year)

  return events
}
